import React, { useState } from 'react';
import { Button, Form, Input, Modal, message } from 'antd';
import "../ModalCom/AddressModal.css";
import { RiHome2Line } from "react-icons/ri";
import { PiBagSimpleBold } from "react-icons/pi";
import { IoLocationOutline } from "react-icons/io5";
import axios from 'axios';

const AddressModal = ({
    isAddressModalOpen,
    addressHandleOk,
    addressHandleCancel,
    setIsAddressModalOpen,
    AllAddress,
    setSelectedAddress,
    fetchAddresses
}) => {
    const profileData = JSON.parse(localStorage.getItem('profile'));
    const [selectedOption, setSelectedOption] = useState('home');

    const [form] = Form.useForm(); // ✅ Form instance

    const options = [
        { key: 'home', icon: <RiHome2Line />, label: 'home' },
        { key: 'work', icon: <PiBagSimpleBold />, label: 'work' },
        { key: 'other', icon: <IoLocationOutline />, label: 'Other' },
    ];

    const handleFinish = async (values) => {
        try {
            const payload = {
                name: values.name,
                address: values.address,
                city: values.city,
                state: values.state,
                pincode: values.pincode,
                landmark: values.landmark,
                address_type: selectedOption,
                alternative_number: values.alternative_number,
                user_id: profileData.id,
                current_active: true,
                is_active: true
            };

            const response = await axios.post(
                'https://api.woodsy.co.in/api/address',
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
console.log("response.data.address_id",response)
            if (response.status >= 200 && response.status < 300) {
                const newAddress = {
                    address_id: response?.data?.data?.address_id,
                    name: values.name,
                    landmark: values.landmark,
                    address_type: selectedOption,
                    alternative_number: values.alternative_number,
                    pincode: values.pincode,
                    address: values.address,
                    city: values.city,
                    state: values.state,
                    user_id: profileData.id,
                    current_active: "1",
                };

                message.success('Address added successfully');
                form.resetFields(); // ✅ Reset form fields
                setSelectedOption('home'); // ✅ Reset address type
                addressHandleCancel(); // Close modal
                setSelectedAddress(newAddress);
                fetchAddresses();
                AllAddress();
            } else {
                throw new Error(response.data?.message || "Failed to add address");
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            message.error(`Failed to add address: ${error.message}`);
        }
    };

    return (
        <Modal
            title="Add address"
            visible={isAddressModalOpen}
            onOk={addressHandleOk}
            onCancel={addressHandleCancel}
            width={1000}
            footer={null}
        >
            <div className='profile-modal-main-con'>
                <div className='address-main-con-form'>
                    <Form
                        form={form} // ✅ Attach form instance
                        layout='vertical'
                        onFinish={handleFinish}
                    >
                        <div className='profile-modal-name-and-surname-con'>
                            <Form.Item
                                name="name"
                                label="Full Name"
                                rules={[{ required: true, message: 'Please enter your full name' }]}
                            >
                                <Input placeholder='Enter A Full Name' />
                            </Form.Item>
                            <Form.Item
                                name="address"
                                label="Address"
                                rules={[{ required: true, message: 'Please enter your address' }]}
                            >
                                <Input placeholder='Enter Address' />
                            </Form.Item>
                            <Form.Item name="landmark" label="Locality (Optional)">
                                <Input placeholder='Landmark' />
                            </Form.Item>
                            <Form.Item
                                name="alternative_number"
                                label="Alternative Number"
                                rules={[
                                    { required: true, message: 'Please enter your contact number' },
                                    { pattern: /^[0-9]{10}$/, message: 'Contact number must be 10 digits' }
                                ]}
                            >
                                <Input placeholder='Enter Contact No.' maxLength={10} />
                            </Form.Item>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <Form.Item
                                        name="city"
                                        label="City"
                                        rules={[{ required: true, message: 'Please enter your city' }]}
                                    >
                                        <Input placeholder='Enter City' />
                                    </Form.Item>
                                </div>
                                <div className='col-md-4'>
                                    <Form.Item
                                        name="state"
                                        label="State"
                                        rules={[{ required: true, message: 'Please enter your state' }]}
                                    >
                                        <Input placeholder='Enter State' />
                                    </Form.Item>
                                </div>
                                <div className='col-md-4'>
                                    <Form.Item
                                        name="pincode"
                                        label="Pincode"
                                        rules={[
                                            { required: true, message: 'Please enter your pincode' },
                                            { pattern: /^[0-9]{6}$/, message: 'Pincode must be 6 digits' }
                                        ]}
                                    >
                                        <Input placeholder='Enter Pincode' maxLength={6} />
                                    </Form.Item>
                                </div>
                            </div>

                            <div className='address-model-order-types-options-main-con'>
                                <h4>Save as</h4>
                                <div className='address-model-order-types-option-row'>
                                    {options.map((option) => (
                                        <div
                                            key={option.key}
                                            className={`address-model-order-types-option-col ${selectedOption === option.key ? 'selected' : ''}`}
                                            onClick={() => setSelectedOption(option.key)}
                                            style={{
                                                border: selectedOption === option.key ? '1px solid black' : '1px solid transparent',
                                                padding: '10px',
                                                cursor: 'pointer',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            {option.icon}
                                            <h5>{option.label}</h5>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <Form.Item>
                            <div className='address-model-btn'>
                                <button type="submit">Submit</button>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </Modal>
    );
};

export default AddressModal;
